import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
  faCheckCircle,
  faPhone,
  faComments,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";
const Service = () => {
  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 }
  };

  const openWhatsApp = () => {
    const phone = "917011468336";
    const message = "Hi ! I am interested, Please contact me.";
    const encoded = encodeURIComponent(message);

    const isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

    const url = isMobile
      ? `https://wa.me/${phone}?text=${encoded}`
      : `https://web.whatsapp.com/send?phone=${phone}&text=${encoded}`;

    window.open(url, "_blank");
  };
  return (
    <div style={{ padding: "160px 0 0 0" }}>
      <section className="container" >

        {/* Modern Title */}
        <div className="d-flex justify-content-center">
          <motion.div
            className="text-center mb-5 p-4 rounded-pill"
            style={{
              backgroundColor: "var(--primary)",
              color: "var(--white)",
              border: "2px solid var(--primary)",
              display: "inline-block",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)"
            }}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <h3 style={{
              margin: 0,
              fontWeight: "700",
              fontSize: "clamp(1.5rem, 2.5vw, 2rem)",
              letterSpacing: "-0.02em"
            }}>
              Products And Solutions Offered
            </h3>
          </motion.div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="row g-4">

          {/* GROUPED TOP THREE SECTIONS - Modern Card Layout */}
          <motion.div
            className="col-12"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            transition={{ duration: 0.6 }}
          >
            <div className="row g-4">
              {[
                {
                  title: "Advisory & Planning",
                  items: "Goal-based Planning | Wealth Management | Retirement | Child Education | Tax Planning | Short-term Investments | Loan Support",
                  icon: "📊"
                },
                {
                  title: "Investment & Planning",
                  items: "Mutual Funds | SIPs | Bonds | Debentures | Fixed Deposits | Digital Gold & Silver ",
                  icon: "💹"
                },
                {
                  title: "Insurance & Protection",
                  items: "Life Insurance | Term Plan | Health & Mediclaim | Accidental Coverage | Critical Illness Coverage ",
                  icon: "🛡️"
                }
              ].map((section, i) => (
                <div key={i} className="col-lg-4 col-md-6 ">
                  <motion.div
                    className="p-4 h-100 rounded-4 position-relative"
                    style={{
                      backgroundColor: "#e8efec",
                      border: "1px solid rgba(52, 92, 82, 0.1)",
                      transition: "all 0.3s ease"
                    }}
                    whileHover={{
                      y: -5,
                      boxShadow: "0 12px 32px rgba(52, 92, 82, 0.15)"
                    }}
                  >
                    {/* Icon Badge */}
                    <div className="d-flex justify-content-center">
                      <div
                        className="mb-3 p-3 rounded-3 d-inline-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "var(--primary)",
                          color: "var(--white)",
                          fontSize: "1.5rem",
                          width: "60px",
                          height: "60px"
                        }}
                      >
                        {section.icon}
                      </div>
                    </div>

                    <div className="d-flex justify-content-center">
                      <h5 className="fw-bold mb-3" style={{
                        color: "var(--heading)",
                        fontSize: "1.25rem"
                      }}>
                        {section.title}
                      </h5>
                    </div>

                    <div style={{ color: "#345c52" }}>
                      {section.items.split(" | ").map((item, idx) => (
                        <div key={idx} className="d-flex align-items-center mb-2">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="me-2"
                            style={{
                              color: "var(--primary)",
                              fontSize: "0.9rem"
                            }}
                          />
                          <span style={{ fontSize: "0.95rem" }}>{item}</span>
                        </div>
                      ))}
                    </div>
                  </motion.div>
                </div>
              ))}
            </div>
          </motion.div>


        </div>

      </section>


      <section className="container " style={{ marginTop: "60px" }}>

        {/* Modern Title */}
        <div className="d-flex justify-content-center">
          <motion.div
            className="text-center mb-5 p-4 rounded-pill"
            style={{
              backgroundColor: "var(--primary)",
              color: "var(--white)",
              border: "2px solid var(--primary)",
              display: "inline-block",
              boxShadow: "0 8px 24px rgba(0, 0, 0, 0.12)"
            }}
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true }}
          >
            <h3 style={{
              margin: 0,
              fontWeight: "700",
              fontSize: "clamp(1.5rem, 2.5vw, 2rem)",
              letterSpacing: "-0.02em"
            }}>
              Our Core Services
            </h3>
          </motion.div>
        </div>

        {/* MAIN CONTENT GRID */}
        <div className="row g-4">

          {/* GROUPED SECTIONS - Modern Card Layout */}
          <motion.div
            className="col-12"
            variants={fadeUp}
            initial="hidden"
            whileInView="show"
            transition={{ duration: 0.6 }}
          >
            <div className="row g-4 justify-content-center">
              {[
                {
                  title: "Financial Goal Analysis",
                  items: [
                    "Understands the investor's financial goals, risk profile, and investment horizon",
                    "Suggests suitable mutual fund schemes (equity, debt, hybrid, etc.) based on investor needs",
                    "Provides goal-based investment planning (e.g., retirement, education, wealth creation)",
                    "Explains mutual fund concepts, features, and benefits in simple terms"
                  ],
                  icon: "🎯"
                },
                {
                  title: "Transaction & Execution Services",
                  items: [
                    "Assists in completing KYC (Know Your Customer) formalities",
                    "Helps investors open mutual fund folios and accounts",
                    "Facilitates purchase, redemption, and switching of mutual fund units",
                    "Assists in setting up SIPs, STPs, and SWPs"
                  ],
                  icon: "⚡"
                },
                {
                  title: "Portfolio Monitoring & Review",
                  items: [
                    "Provides regular portfolio reviews to track performance",
                    "Recommends portfolio rebalancing based on market conditions and goal progress",
                    "Tracks dividends, capital gains, and NAV movements"
                  ],
                  icon: "📊"
                },
                {
                  title: "Documentation & Compliance Support",
                  items: [
                    "Ensures completion of all regulatory and compliance requirements (KYC, FATCA, etc.)",
                    "Maintains records of investor transactions and statements",
                    "Provides assistance in nomination and transmission cases"
                  ],
                  icon: "📝"
                },
                {
                  title: "Reporting & Transparency",
                  items: [
                    "Provides regular account statements and performance reports",
                    "Keeps investors updated about fund changes, mergers, or regulatory updates"
                  ],
                  icon: "📈"
                },
                {
                  title: "After-Sales & Investor Support",
                  items: [
                    "Offers ongoing assistance for queries and service requests",
                    "Helps in grievance redressal with AMC or Registrar",
                    "Educates investors about new mutual fund products and market developments"
                  ],
                  icon: "🤝"
                },
                {
                  title: "Claim Assistance",
                  items: [
                    "Guides client during claim filing in Life Insurance & Mediclaim cases",
                    "Coordinates with insurer for quicker claim settlement"
                  ],
                  icon: "🛟"
                },
                {
                  title: "Investor Education",
                  items: [
                    "Helping Investors to increase  their Financial Awareness through social media campaign",
                    "Promotes disciplined investing habits (SIP, long-term focus, diversification)"
                  ],
                  icon: "🎓"
                }, {
                  title: "Loan Assistance",
                  items: [
                    "Evaluation & Processing of Home loans , Business Loans , Balance Transfer , Top up Loans etc from all leading banks & NBFCs",
                    "Application process handling - Filing Loan , Coordinating with bank for smooth & timely loan disbursal"
                  ],
                  icon: "🏦"
                }
              ].map((section, i) => (
                <div key={i} className="col-lg-4 col-md-6">
                  <motion.div
                    className="p-4 h-100 rounded-4 position-relative"
                    style={{
                      backgroundColor: "#e8efec",
                      border: "1px solid rgba(52, 92, 82, 0.1)",
                      transition: "all 0.3s ease"
                    }}
                    whileHover={{
                      y: -5,
                      boxShadow: "0 12px 32px rgba(52, 92, 82, 0.15)"
                    }}
                  >
                    {/* Icon Badge */}
                    <div className="d-flex justify-content-center">
                      <div
                        className="mb-3 p-3 rounded-3 d-inline-flex align-items-center justify-content-center"
                        style={{
                          backgroundColor: "var(--primary)",
                          color: "var(--white)",
                          fontSize: "1.5rem",
                          width: "60px",
                          height: "60px"
                        }}
                      >
                        {section.icon}
                      </div>
                    </div>

                    <div className=" d-flex justify-content-center">
                      <h5 className="fw-bold mb-3" style={{
                        color: "var(--heading)",
                        fontSize: "1.25rem"
                      }}>
                        {section.title}
                      </h5>
                    </div>

                    <div style={{ color: "#345c52" }}>
                      {section.items.map((item, idx) => (
                        <div key={idx} className="d-flex align-items-center mb-2">
                          <FontAwesomeIcon
                            icon={faCheckCircle}
                            className="me-2"
                            style={{
                              color: "var(--primary)",
                              fontSize: "0.9rem"
                            }}
                          />
                          <span style={{ fontSize: "0.95rem" }}>{item}</span>
                        </div>
                      ))}
                    </div>
                  </motion.div>
                </div>
              ))}
            </div>
          </motion.div>

        </div>

      </section>



      {/* ===== Why Clients Choose SAG Financials ===== */}
      <section
        className="container py-4 mt-3"
        style={{ backgroundColor: "var(--light-bg)" }}
      >
        <div className="text-center mb-5">
          <motion.h2
            className="fw-bold mb-3"
            style={{ color: "var(--heading)" }}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Why Clients Choose SAG Financials ?
          </motion.h2>

          <motion.p
            className="mx-auto d-none"
            style={{
              color: "var(--text)",
              maxWidth: "700px",
              fontSize: "1.1rem",
            }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            We’re proud to be a boutique financial advisory firm — Small in size,
            big on impact. Here’s what makes us different:
          </motion.p>
        </div>

        <div className="row g-4">
          {[
            "Truly Personalized Planning – Strategies built around your life, not templates.",
            "Certified & Ethical – AMFI, IRDA, and NISM certified with top ethical standards.",
            "Digital Convenience, Human Touch – Manage finances digitally with personal support.",
            "22+ Years of Experience – Over two decades of financial expertise.",
            "Award-Winning Performance – MDRT-level achievements and client satisfaction.",
            "Comprehensive Financial Solutions – From investments to insurance, all under one roof.",
          ].map((point, idx) => (
            <motion.div
              key={idx}
              className="col-md-6 col-lg-4"
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.15, duration: 0.6 }}
            >
              <div
                className="p-4 border rounded shadow-sm h-100"
                style={{
                  backgroundColor: "var(--white)",
                  borderColor: "var(--secondary) !important",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-8px)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 18px rgba(0,0,0,0.15)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "none";
                }}
              >
                <FontAwesomeIcon
                  icon={faCheck}
                  style={{
                    color: "var(--primary)",
                    marginRight: "10px",
                    fontSize: "1.3rem",
                  }}
                />
                <span style={{ color: "var(--text)", fontWeight: 500 }}>
                  {point}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
      </section>



      {/* ===== How to Get Started ===== */}
      <div style={{ padding: "10px" }}>
        <section
          id="get-started"
          className="container py-5 text-center mt-3"
          style={{
            backgroundColor: "var(--light-bg)",
            border: "3px solid var(--secondary)", // green border
            borderRadius: "20px",        // rounded corners
            boxShadow: "0 4px 20px rgba(0, 128, 0, 0.1)", // soft green shadow
          }}
        >
          <motion.h2
            className="fw-bold mb-4"
            style={{ color: "var(--heading)" }}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            How to Get Started ?
          </motion.h2>

          <motion.p
            className="mb-4 mx-auto"
            style={{
              color: "var(--text)",
              maxWidth: "750px",
              fontSize: "1.1rem",
            }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ delay: 0.3 }}
          >
            Financial planning doesn’t have to be complicated. With SAG Financials,
            you’ll always have a clear path forward and a partner who listens.
          </motion.p>

          <div className="d-flex flex-wrap justify-content-center gap-4 fs-5">
            {[
              {
                icon: faPhone,
                text: "Book a free, no-obligation consultation",
                link: "tel:+917011468336",
              },
              {
                icon: faComments,
                text: "Talk to us via WhatsApp or email",
                onClick: () => openWhatsApp(),
              },
              {
                icon: faStar,
                text: "Start building your future — with expert support",
                link: "/contact",
              },
            ].map((item, i) => (
              <motion.a
                key={i}
                href={item.link || undefined}
                onClick={item.onClick}
                className="px-4 py-3 border rounded shadow-sm bg-white text-decoration-none"
                style={{
                  minWidth: "300px",
                  color: "var(--text)",
                  borderColor: "var(--secondary) !important",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: item.onClick ? "pointer" : "default",
                  transition: "transform 0.3s ease, box-shadow 0.3s ease",
                }}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.15 }}
                whileHover={{
                  scale: 1.05,
                  boxShadow: "0 10px 25px rgba(0,0,0,0.15)",
                }}
              >
                <FontAwesomeIcon
                  icon={item.icon}
                  style={{
                    color: "var(--primary)",
                    marginRight: "10px",
                  }}
                />
                {item.text}
              </motion.a>
            ))}
          </div>

        </section>
      </div>


    </div>
  );
};

export default Service;
